import { z } from 'zod';

/**
 * The installed app: its colours and icon set, which management sets in
 * Settings, and the Web App Manifest built from them. Request of 5 October 2026.
 */

const HexColorSchema = z
  .string()
  .regex(/^#[0-9a-fA-F]{6}$/, 'Choose a colour as #rrggbb, for example #15130f.');

export const PwaSettingsSchema = z.object({
  themeColor: HexColorSchema,
  backgroundColor: HexColorSchema,
  /** The uploaded icon set's version, or null for the built in icons. */
  iconVersion: z.string().nullable(),
  defaultThemeColor: HexColorSchema,
  defaultBackgroundColor: HexColorSchema,
});

export const SavePwaSettingsSchema = z.object({
  themeColor: HexColorSchema,
  backgroundColor: HexColorSchema,
});

const ManifestIconSchema = z.object({
  src: z.string(),
  sizes: z.string(),
  type: z.string(),
  purpose: z.enum(['any', 'maskable']),
});

/** `GET /pwa/manifest.webmanifest`, public, as `application/manifest+json`. */
export const WebManifestSchema = z.object({
  id: z.literal('/'),
  name: z.string(),
  short_name: z.string(),
  description: z.string(),
  start_url: z.literal('/'),
  scope: z.literal('/'),
  display: z.literal('standalone'),
  orientation: z.string(),
  lang: z.string(),
  theme_color: HexColorSchema,
  background_color: HexColorSchema,
  icons: z.array(ManifestIconSchema).min(3),
});

export type PwaSettings = z.infer<typeof PwaSettingsSchema>;
export type WebManifest = z.infer<typeof WebManifestSchema>;
